import { render, staticRenderFns } from "./SearchBannerContentSkeleton.vue?vue&type=template&id=19d9e7b9&scoped=true&"
import script from "./SearchBannerContentSkeleton.vue?vue&type=script&lang=ts&"
export * from "./SearchBannerContentSkeleton.vue?vue&type=script&lang=ts&"
import style0 from "./SearchBannerContentSkeleton.vue?vue&type=style&index=0&id=19d9e7b9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19d9e7b9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19d9e7b9')) {
      api.createRecord('19d9e7b9', component.options)
    } else {
      api.reload('19d9e7b9', component.options)
    }
    module.hot.accept("./SearchBannerContentSkeleton.vue?vue&type=template&id=19d9e7b9&scoped=true&", function () {
      api.rerender('19d9e7b9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "module/Deals/view/vue/components/banner/skeletons/SearchBannerContentSkeleton.vue"
export default component.exports